import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spaceSeparator',
  pure: false,
})
export class SpaceSeparatorPipe implements PipeTransform {
  transform(value: string, nbChar = 1): string | null {
    return !value ? null : value.replace(new RegExp('(.{' + nbChar + '})', 'g'), '$1 ').trim();
  }
}
